import React from 'react';
import { useRoutes } from 'hookrouter';
import ForgotCredentialsPage from 'pages/mortgage/forgotCredentials';
import ForgotPasswordPage from 'pages/mortgage/forgotPassword';
import ForgotUsernamePage from 'pages/mortgage/forgotUsername';
import MortgageSignInPage from 'pages/mortgage/signIn';
import PostSignInForMortgagePage from 'pages/mortgage/postSignIn';
import SignUpPage from 'pages/mortgage/signUp';
import SignUpSuccessPage from 'pages/mortgage/signUp/success';

const routes = {
  '/forgot-credentials': () => <ForgotCredentialsPage />,
  '/forgot-password': () => <ForgotPasswordPage />,
  '/forgot-username': () => <ForgotUsernamePage />,
  '/sign-in': () => <MortgageSignInPage />,
  '/sign-in/post-processing': () => <PostSignInForMortgagePage />,
  '/sign-up': () => <SignUpPage />,
  '/sign-up/success': () => <SignUpSuccessPage />,
};

const MortgageArea = () => {
  return useRoutes(routes);
};

export default MortgageArea;
